export const beforeItems = [
  "You look at a new case and immediately have dozens of things running through your head.",
  "You jump between diagnosis, objectives, mechanics, anchorage and movement.",
  "Important findings are scattered across photographs, radiographs, notes and previous references.",
  "You know several things you need to consider, but you're not sure what should come first.",
  "You may spend time reviewing textbooks, courses, screenshots or previous cases before you can organize your thinking.",
  "Every complex case feels like you have to rebuild your planning process from scratch.",
];

export const afterItems = [
  "You begin with a structured case snapshot.",
  "You separate findings from problems.",
  "You separate problems from objectives.",
  "You establish priorities before jumping into mechanics.",
  "You map important constraints before deciding on a sequence.",
  "You can see the major planning components together instead of keeping everything in your head.",
];

export const painPoints = [
  "You have a case in front of you and know there are several factors to consider, but you're unsure what deserves attention first.",
  "You spend too much time reviewing information before you can turn it into a coherent strategy.",
  "You understand individual orthodontic concepts, but connecting those concepts into one organized case strategy is still difficult.",
  "You sometimes think about appliances, mechanics or tooth movement before you've completely organized the objectives and priorities.",
  "You worry about overlooking an important constraint or sequencing issue before treatment begins.",
  "You find yourself mentally rebuilding the same planning process every time a new complex case appears.",
];
